// extracted by mini-css-extract-plugin
export default {"helperText":"CodeEditorModeWarningBanner_helperText__1E3_2","helperIcon":"CodeEditorModeWarningBanner_helperIcon__Ob_TT","helperLink":"CodeEditorModeWarningBanner_helperLink__2p6R6"};